var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-page-content-template',{attrs:{"title":"エステカレンダー","subtitle":"Esthe Calendar"}},[_c('kawaii-calendar',{attrs:{"user-ids":[_vm.user.userId]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }